import { Plus } from 'lucide-react';

/**
 * The page's primary CTA.
 *
 * `rounded-lg` is 8px — both what every other button on this page uses and what
 * `--nb-radius-btn` gives the dashboards' own `.nb-btn`, so this matches "Add
 * venue" on /admin/venues instead of being the one pill-shaped button in the app.
 * Every other `rounded-full` on this page is a pill, badge, dot or avatar, where
 * it belongs.
 *
 * NOT switched to `.nb-btn nb-btn-primary` itself: those rules are scoped under
 * `.nb-dashboards`, and this button sits outside that island, so the classes
 * would style nothing at all.
 *
 * The mobile FAB keeps its pill deliberately — a floating action button is a
 * different control, and every platform draws it round.
 */
export function NewBookingButton({ fab = false, onClick }: { fab?: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-2 bg-moss-600 font-semibold text-white transition hover:bg-moss-700 ${
        fab ? 'rounded-full px-5 py-3.5 text-sm shadow-lg' : 'rounded-lg px-5 py-2.5 text-sm'
      }`}
    >
      <Plus size={fab ? 18 : 16} />
      New booking
    </button>
  );
}
